import { MouseEvent, useEffect, useRef } from "react";

import { SetModalProps } from "contexts/UIContext/types";
import { useAppUI } from "contexts/UIContext";
import "./styles.scss";



function AppModal({
  hideDefaultControls = false,
  title,
  controls,
  children,
  width = "420px",
  cancelCallback,
}: SetModalProps) {
  const modalRef = useRef<HTMLDivElement>(null);
  const { closeModal: closeAppModal } = useAppUI();


  /*************
   * Close Modal
   */
  const closeModal = (e?: MouseEvent) => {
    if (e) e.preventDefault();
    closeAppModal();
    if (cancelCallback) cancelCallback();
  }


  // Effect for closing modal on outside click
  useEffect(() => {
    const handleOutsideClick: EventListener = (event) => {
      const mouseEvent = event as any;
      const target = mouseEvent.target as Node;
      if (modalRef.current && !modalRef.current.contains(target)) {
        closeModal();
      }
    }
    document.addEventListener(
      "mousedown",
      handleOutsideClick
    );

    return () => (
      document.removeEventListener(
        "mousedown",
        handleOutsideClick
      )
    );
  }, [closeModal]);

  // Effect for closing modal on Escape key press
  useEffect(() => {
    const handleEscapePress = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        closeModal();
      }
    }
    document.addEventListener(
      "keydown",
      handleEscapePress
    );

    return () => (
      document.removeEventListener(
        "keydown",
        handleEscapePress
      )
    );
  }, [closeModal]);



  return (
    children ? (
      <div className="app-modal">
        <div className="modal-overlay">
          <div
            className="modal-container" ref={modalRef}
            style={{ width }}
          >
            {/* Modal Header */}
            <div className="header d-flex justify-content-center">
              <h1 className="head-title">{title}</h1>
            </div>

            {/* Modal Content */}
            {(typeof children === "string") ? (
              <div className="content">
                {children}
              </div>
            ) : children}

            {/*  Modal Controls */}
            {controls ? (
              controls
            ) : hideDefaultControls ? (
              null
            ) : (
              <div className="modal-controls">
                <button
                  className="btn btn-secondary"
                  onClick={closeModal}
                >
                  Okay
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    ) : null
  );
}

export default AppModal;